export default {
  name: 'channelOutput',
  data() {
    return {
      loading:false,
      list:[],
      total:0,
      pageSize:8,
      pageIndex:1
    }
  },
  watch:{
  },
  filters: {
    parseDate: function (value) {
      return value.substring(0,10);
    }
  },
  computed:{
    pageCount(){
      return Math.ceil(this.total/this.pageSize);
    },
    type(){
      return this.$route.query.type;
    }
  },
  created() {
    this.getdatalist();
  },
  mounted() {
	},
  methods: {
    getdatalist(){
      this.loading=true;
      this.$http.get('front/channel',{params:{
        pagesize:this.pageSize,
        pageindex:this.pageIndex-1,
        type:'SinaMicroBlog',
        ptype:this.type,
        audit:true
      }
      }).then((res)=>{
        this.loading=false;
        // console.log(res);
        if(res.data.status == 1){
          this.total=res.data.total;
          this.list=res.data.channels;
        }else{
          this.total=0;
          this.$Notice.error({title:res.data.message,desc:false});
        }
      },(error)=>{
        this.loading=false;
        this.total=0;
        this.$Notice.success({title:error.data.message,desc:false});
      })
    },
    confirmPop(content,callback){
       this.$Modal.confirm({
        title: '确认提示',
        content: content,
        onOk: () => {
          callback();
        }
      });
    },
    checkblog(id,status){
      this.$http.put('front/channel/audit/'+id,{status:status}).then(( response ) =>{
        if(response.data.status == 1){
          this.$Notice.success({title:response.data.message,desc:false})
          //重新获得列表
          this.getdatalist();
        }else{
          this.$Notice.error({title:response.data.message,desc:false})
        }
      },(error)=>{
        this.$Notice.error({title:error.data.message,desc:false})
      })
    },
    pass(id){
      this.confirmPop('你确定要审核通过吗？',()=>{this.checkblog(id,'auditpassed')});
    },
    nopass(id){
      this.confirmPop('你确定要审核不通过吗？',()=>{this.checkblog(id,'auditnotpass')});
    },
    changePage(page){
      this.pageIndex=page;
      this.getdatalist();
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/channel/microbloglist/index.js